export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1440w.a4e6d471.webp";